import { ReplaySubject, Subject } from "rxjs";

import { MarketType } from "../types/betfair/betfair-message";
import { PricingStrategy } from "../types/enums/pricing-strategy";
import { showMessage } from "../types/services";

import { HttpService } from "./http-service";

export class CustomPriceGenerationService {
  public currentPriceSubject: Subject<Map<string, number>> = new ReplaySubject(
    1
  );

  private readonly httpService: HttpService;
  private readonly baseUrl: string = "/api/custom-price-generation-controller";

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  }

  public calculatePrice(
    mean: number,
    standardDeviation: number,
    pricingStrategy: PricingStrategy,
    marketType: MarketType,
    runners: string[]
  ): Promise<void> {
    return this.httpService
      .post(this.baseUrl + "/calculate-price", {
        mean,
        standardDeviation,
        pricingStrategy,
        marketType,
        runners,
      })
      .then((response: any) => {
        const runnerPriceMap: Map<string, number> =
          this.deserializeRunnerPriceMap(response);
        this.currentPriceSubject.next(runnerPriceMap);
      })
      .catch((reason) =>
        showMessage(`Failed to calculate price: ${reason}`, "error")
      );
  }

  public deserializeRunnerPriceMap(response: any): Map<string, number> {
    if (!response) {
      return new Map();
    }

    return new Map(Object.entries(response));
  }
}
